
import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import waterMark from "@/lib/waterMark";

@Component({
  name: "App"
})
export default class extends Vue {
  mounted() {
    if (this.User&&!UserModule.user.isEdcationUser) {
      waterMark.set("为垦小绿伞_" + this.User.name);
    }
  }

  get User() {
    return UserModule.user;
  }
}
